import React from 'react';
import { RewardModel } from '../../../models/rewardModel';

import './Rewards.scss';
import blankRewardSvg from '../../../assets/rewards/blank-reward.svg';
import rarityIconSvg from '../../../assets/rewards/rarity-icon.svg';

interface Props {
  reward: RewardModel;
  onClick?: () => void;
  // eslint-disable-next-line dubit-ts/props-name-boolean-values-as-directives
  claimed: boolean;
  canClaimRewards: boolean;
}

// There seems to be an issue with the no-shadow rule:
// eslint-disable-next-line max-len
// https://stackoverflow.com/questions/63961803/eslint-says-all-enums-in-typescript-app-are-already-declared-in-the-upper-scope
// eslint-disable-next-line no-shadow
enum REWARD_RARITY {
  Common = 1,
  Moderate = 2,
  Uncommon = 3,
  Rare = 4,
  ExtremelyRare = 5,
}

/**
 * Component that shows renders a reward and a counter for how many there are.
 */
const ClaimableReward = ({
  reward, onClick, claimed, canClaimRewards,
}: Props): React.ReactElement => {
  const { imageUrl, rarityScore } = reward;
  const isRare = rarityScore > REWARD_RARITY.Rare;

  const classNames = [
    'list-item',
    'claimable-reward',
    claimed ? 'claimed' : 'unclaimed',
    canClaimRewards ? undefined : 'blocked',
  ];

  return (
    <div
      role="presentation"
      onClick={() => onClick?.()}
      className={classNames.join(' ')}
    >
      <img
        src={claimed ? imageUrl : blankRewardSvg}
        alt={`${claimed ? 'Claimed' : 'A random, unclaimed'} reward`}
      />

      {isRare && (
        <div className="rare">
          <img src={rarityIconSvg} alt="rare" />
        </div>
      )}
    </div>
  );
};

export default ClaimableReward;
